import { render, staticRenderFns } from "./CaseCoefficientConfig.vue?vue&type=template&id=97bb416a&scoped=true&"
import script from "./CaseCoefficientConfig.vue?vue&type=script&lang=js&"
export * from "./CaseCoefficientConfig.vue?vue&type=script&lang=js&"
import style0 from "./CaseCoefficientConfig.vue?vue&type=style&index=0&id=97bb416a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bb416a",
  null
  
)

export default component.exports